import type { ReactElement, ReactNode } from 'react';

import { cn } from '../lib/cn';

export interface AppShellProps {
  sidebar: ReactNode;
  topbar: ReactNode;
  /** Conteúdo principal */
  children: ReactNode;
  /** Drawer mobile (renderizado escondido por default; controlado externamente) */
  mobileDrawer?: ReactNode;
  className?: string;
}

export function AppShell({
  sidebar,
  topbar,
  children,
  mobileDrawer,
  className,
}: AppShellProps): ReactElement {
  return (
    <div className={cn('bg-bg text-ink flex min-h-screen', className)}>
      <div className="hidden lg:flex">{sidebar}</div>
      {mobileDrawer ? <div className="lg:hidden">{mobileDrawer}</div> : null}
      <div className="flex min-w-0 flex-1 flex-col">
        {topbar}
        <main className="flex-1 px-4 py-6 sm:px-6 lg:px-10 lg:py-8">{children}</main>
      </div>
    </div>
  );
}
